import line from '../../../assets/line-footer-top.png'
import './Footer.css'

export default () => {
    return (
        <>
            <footer className="footer-main">
                
                <div className='footer-section2'>
                    <div className='text-footer-section2'>
                        <h3>CAP/ETS - All rights reserved</h3>
                        <h3>© Datawize 2023</h3>
                    </div>
                </div>
                <img className='supergraphic' src={line}/>

            </footer>
        </>
    )
}